import { Icon, Text } from '@ui/themed';
import type { PropsWithChildren } from 'react';
import { TEXT_VARIANT_MAP } from '../ui/text/text.spark';
import type { UnorderedListItemProps } from './types';

export function UnorderedList({ children }: PropsWithChildren) {
  return <ul className="flex flex-col gap-0.5">{children}</ul>;
}

function UnorderedListItem({ children, variant = 'primary', iconName }: UnorderedListItemProps) {
  return (
    <li>
      <div className={`flex flex-row items-center gap-2 ${TEXT_VARIANT_MAP[variant]}`}>
        {!iconName ? (
          <span className="size-1 shrink-0 rounded-full bg-current"></span>
        ) : (
          <Icon name={iconName} size="sm" />
        )}
        <Text variant={variant} size="md">
          {children}
        </Text>
      </div>
    </li>
  );
}

UnorderedList.Item = UnorderedListItem;
